import PwmEditor from './PwmEditor'

export default PwmEditor
